import React from 'react';
import {
  List, Datagrid, TextField, NumberField, DateField,
  Edit, Create, TabbedForm, FormTab, TextInput, NumberInput,
  ReferenceInput, AutocompleteInput, required, minValue, maxValue
} from 'react-admin';
import { Box } from '@material-ui/core';
import { SectionHeader } from './components/utils';
import ConversionPixelField from './components/ConversionPixelField';
import { ChipInput } from './components/chipInput';

const twoColumnGrid = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 24px', width: '50%' };

export const AudienceList = (props) => (
  <List {...props} sort={{ field: 'code', order: 'DESC' }} perPage={25} bulkActionButtons={false}>
    <Datagrid rowClick="edit">
      <TextField source="code" label="ID" />
      <TextField source="name" label="Name" />
      <NumberField source="windowDays" label="Window (days)" />
      <DateField source="refreshedAt" label="Last Refreshed" showTime />
    </Datagrid>
  </List>
);

// Shared Settings fields so Edit and Create cannot drift. Rendered inside a
// literal <FormTab> in each form (FormTab must be the direct TabbedForm child
// so react-admin can build the tab header label).
const AudienceSettingsFields = () => (
  <Box style={twoColumnGrid}>
    <SectionHeader title="Audience" />
    <TextInput source="name" label="Name" validate={required()} style={{ maxWidth: 256 }} />
    <ReferenceInput label="Advertiser *"
      source="advertiser_id"
      reference="advertisers"
      basePath="advertisers"
      perPage={15}
      sort={{ field: 'name', order: 'ASC' }}
      filterToQuery={searchText => ({ search_name: searchText })}>
      <AutocompleteInput
        optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ''}
        optionValue="code"
        validate={required()}
        style={{ maxWidth: 256 }} />
    </ReferenceInput>
    <NumberInput source="windowDays" label="Seed window (days)" defaultValue={30} min={1} max={365} step={1}
      helperText="How many days of recent conversions are used to build this audience's profile. It's a rolling window — conversions older than this drop off, so a smaller number reacts faster while a larger one is more stable."
      validate={[required(), minValue(1, 'Seed window must be at least 1 day'), maxValue(365, 'Seed window must be 365 days or fewer')]} style={{ maxWidth: 256 }} />
    <SectionHeader title="Contextual Matching" />
    <ChipInput source="keywords" label="Keywords" fullWidth />
  </Box>
);

export const AudienceEdit = (props) => (
  <Edit {...props}>
    <TabbedForm>
      <FormTab label="Settings">
        <AudienceSettingsFields />
      </FormTab>
      <FormTab label="Conversion Pixel">
        <ConversionPixelField />
      </FormTab>
    </TabbedForm>
  </Edit>
);

export const AudienceCreate = (props) => (
  <Create {...props}>
    <TabbedForm>
      <FormTab label="Settings">
        <AudienceSettingsFields />
      </FormTab>
    </TabbedForm>
  </Create>
);
